import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { ChromePicker } from 'react-color';
import { ColorCover, ColorPopover, ColorSelectIcon, Root } from '../styles';
var ColorsInput = function (props) {
    var id = props.id, caption = props.caption, tooltip = props.tooltip, value = props.value, _a = props.size, size = _a === void 0 ? 'small' : _a, _b = props.inside, inside = _b === void 0 ? false : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, onChange = props.onChange;
    var _d = useState(false), visible = _d[0], setVisible = _d[1];
    var handleClick = function () {
        setVisible(!visible);
    };
    var handleClose = function () {
        setVisible(false);
    };
    var inputProps = {
        endAdornment: (React.createElement(InputAdornment, { position: "end" },
            React.createElement(IconButton, { disabled: disabled, onClick: handleClick },
                React.createElement(ColorSelectIcon, { value: value })))),
    };
    var onValueChange = function (e) {
        onChange(e.target.value);
    };
    var onColorChange = function (color) {
        var _a = color === null || color === void 0 ? void 0 : color.rgb, _b = _a.r, r = _b === void 0 ? 0 : _b, _c = _a.g, g = _c === void 0 ? 0 : _c, _d = _a.b, b = _d === void 0 ? 0 : _d, _e = _a.a, a = _e === void 0 ? 1 : _e;
        onChange(a === 1 ? "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")") : "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")"));
    };
    return (React.createElement(Root, { relative: true, size: size, inside: inside, button: true },
        React.createElement(TextField, { id: id, label: caption, helperText: tooltip, value: value, variant: "outlined", size: "small", disabled: disabled, InputProps: inputProps, onChange: onValueChange }),
        visible && (React.createElement(ColorPopover, null,
            React.createElement(ColorCover, { onClick: handleClose }),
            React.createElement(ChromePicker, { color: value, onChange: onColorChange })))));
};
ColorsInput.defaultProps = {
    size: 'small',
    tooltip: '',
    inside: false,
    disabled: false,
    onChange: undefined,
};
export default ColorsInput;
//# sourceMappingURL=ColorsInput.js.map